<script setup lang="ts">
import { type Emoji } from '#shared'
import EmojiCell from './emoji-cell.vue'

const props = defineProps<{ emojis: Emoji[] }>()

const emit = defineEmits<{ select: [emoji: Emoji] }>()

const onSelect = (emoji: Emoji) => {
  emit('select', emoji)
}
</script>

<template>
  <EmojiCell v-for="emoji in props.emojis" :key="emoji.id" :emoji="emoji" @select="onSelect" />
</template>
